import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

const EmptyHistory = () => {
  const { t } = useTranslation();

  return (
    <div className="empty_list">
      <div className="empty_list-icon">
        <FontAwesomeIcon icon="list-ul" />
      </div>
      <div className="empty_list-label">
        <p>{t('withoutPreviousVersions')}</p>
      </div>
    </div>
  );
};

export default EmptyHistory;
